module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0764-min.922318d7.jpg";